import React, { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { signout } from '../../helpers/auth';
import { getCurrentUser } from '../../helpers/users';
import { auth } from './../../services/Firebase';

const Header = () => {

    const handleSignOut = async () => {
        try {
            await signout();
        } catch (error) {
            console.log(error);
        }
    }

    const [authentificated, setAuthentificated] = useState(false);

    const [currentUser, setCurrentUser] = useState(getCurrentUser());

    useEffect(() => {

        auth().onAuthStateChanged((user) => {
            if (user) {
                setAuthentificated(true);
            } else {
                setAuthentificated(false);
            }

        });

        (function (window, document, undefined) {
            'use strict';
            if (!('localStorage' in window)) return;
            var nightMode = localStorage.getItem('gmtNightMode');
            if (nightMode) {
                document.documentElement.className += ' night-mode';
            }
        })(window, document);


        (function (window, document, undefined) {

            'use strict';

            // Feature test
            if (!('localStorage' in window)) return;

            // Get our newly insert toggle
            var nightMode = document.querySelector('#night-mode');
            if (!nightMode) return;

            // When clicked, toggle night mode on or off
            nightMode.addEventListener('click', function (event) {
                event.preventDefault();
                document.documentElement.classList.toggle('night-mode');
                if (document.documentElement.classList.contains('night-mode')) {
                    localStorage.setItem('gmtNightMode', true);
                    return;
                }
                localStorage.removeItem('gmtNightMode');
            }, false);

        })(window, document);

        return () => {

        }
    }, [])


    return (
        <header className="header header-horizontal header bg-grey uk-light">

            <div className="container">
                <nav uk-navbar="">

                    <div className="uk-navbar-left">

                        <span className="mmenu-trigger">
                            <button className="hamburger hamburger--collapse" type="button">
                                <span className="hamburger-box">
                                    <span className="hamburger-inner"></span>
                                </span>
                            </button>
                        </span>

                        <a href="dashboard.html" className="logo">
                            {/* <img src="../../assets/images/logo-dark.svg" alt="" /> */}
                            <span style={{color: "white"}}> Léo Tech's</span>
                        </a>


                        <nav id="navigation">
                            <ul id="responsive">
                                <li><a href="/">Accueil</a> </li>
                                <li><a href="#">Explorer</a>
                                    <ul className="dropdown-nav nav-large nav-courses">

                                        <li>
                                            <a href="course-card.html#">
                                                <i className="icon-brand-js-square" style={{ color: '#f7df1e' }}></i> JavaScript
                                            </a>
                                        </li>
                                        <li><a href="course-card.html">
                                            <i className="icon-brand-node-js" style={{ color: 'green' }}></i> NodeJS </a>
                                        </li>
                                        <li><a href="course-card.html">
                                            <i className="icon-brand-angular" style={{ color: "#dd0031" }}></i> Angular </a>
                                        </li>
                                        <li><a href="course-card.html">
                                            <i className="icon-brand-css3-alt" style={{ color: "blue" }}></i> CSS </a></li>
                                        <li><a href="course-card.html">
                                            <i className="icon-brand-html5" style={{ color: "#f0653f" }}></i> HTML5 </a></li>
                                        <li><a href="course-card.html">
                                            <i className="icon-brand-react" style={{ color: "#67fcef" }}></i> React </a></li>
                                        <li><a href="course-card.html">
                                            <i className="icon-brand-vuejs" style={{ color: "green" }}></i> Vue JS </a></li>
                                        <li><a href="course-card.html">
                                            <i className="icon-brand-python" style={{ color: "#b1b172" }}></i> Python </a>
                                        </li>

                                    </ul>
                                </li>
                                <li><a href="book.html">Livres</a> </li>
                                <li><a href="blog-1.html">Blog</a> </li>
                                <li><a href="#">Pages</a>
                                    <ul className="dropdown-nav">
                                        <li><a href="page-pricing.html">Prix</a> </li>
                                        <li><a href="page-contact.html">Contacts</a></li>
                                        <li><a href="#">Account</a>
                                            <ul className="dropdown-nav">
                                                <li><a href="page-login.html">Connexion</a></li>
                                                <li><a href="page-register.html">Inscription</a></li>
                                                <li><a href="page-simple-login.html">Simple login</a></li>
                                                <li><a href="page-simple-register.html">Simple register</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>

                    </div>



                    <div className="uk-navbar-right">

                        <div className="header-widget">

                            <div className="searchbox uk-visible@s">

                                <input className="uk-search-input" type="search" placeholder="Rechercher..." />
                                <button className="btn-searchbox"> </button>

                            </div>
                            <div uk-dropdown="pos: top;mode:click;animation: uk-animation-slide-bottom-small"
                                className="dropdown-search">
                                <div className="erh BR9 MIw"
                                    style={{ top: "-27px", position: "absolute", left: "24px", fill: "currentColor", height: "24px", pointerEvents: "none", color: "#f5f5f5" }}>
                                    <svg width="22" height="22">
                                        <path d="M0 24 L12 12 L24 24"></path>
                                    </svg>
                                </div>

                                <ul className="dropdown-search-list">
                                    <li className="list-title">
                                        Recherches récentes
                                    </li>
                                    <li><a href="course-intro.html">
                                        Bootstrap 4 From Scratch With 5 Real Projects </a>
                                    </li>
                                    <li> <a href="course-intro.html">
                                        The Complete 2020 Web Development Bootcamp </a>
                                    </li>
                                </ul>

                            </div>


                            {authentificated == true &&
                                <Fragment>
                                    <span className="icon-feather-x icon-small uk-hidden@s"
                                        uk-toggle="target: .header-widget ; cls: is-active"> </span>


                                    <a href="#" className="header-widget-icon"
                                        uk-tooltip="title: My Courses ; pos: bottom ;offset:21">
                                        <i className="uil-youtube-alt"></i>
                                    </a>

                                    <div uk-dropdown="pos: top;mode:click;animation: uk-animation-slide-bottom-small"
                                        className="dropdown-notifications my-courses-dropdown">

                                        <div className="dropdown-notifications-headline">
                                            <h4>Vos cours</h4>
                                            <a href="#">
                                                <i className="icon-feather-settings"
                                                    uk-tooltip="title: Notifications settings ; pos: left"></i>
                                            </a>
                                        </div>

                                        <div className="dropdown-notifications-content" data-simplebar="">

                                            <ul>
                                                <li className="notifications-not-read">
                                                    <a href="course-intro.html">
                                                        <span className="notification-image">
                                                            <img src="../../assets/images/course/1.png" alt="" /> </span>
                                                        <span className="notification-text">
                                                            <span className="course-title">Ultimate Web Designer & Web Developer
                                </span>
                                                            <span className="course-number">6/35 </span>
                                                            <span className="course-progressbar">
                                                                <span className="course-progressbar-filler"
                                                                    style={{ width: "95%" }}></span>
                                                            </span>
                                                        </span>

                                                        <span className="btn-option">
                                                            <i className="icon-feather-more-vertical"></i>
                                                        </span>
                                                        <div className="dropdown-option-nav"
                                                            uk-dropdown="pos: bottom-right ;mode : hover">
                                                            <ul>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-material-outline-dashboard"></i>
                                            Course Dashboard</span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-feather-video"></i>
                                            Resume Course</span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-feather-x"></i>
                                            Remove Course</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </a>

                                                </li>
                                                <li>
                                                    <a href="course-intro.html">
                                                        <span className="notification-image">
                                                            <img src="../../assets/images/course/3.png" alt="" /> </span>
                                                        <span className="notification-text">
                                                            <span className="course-title">The Complete JavaScript Course Build Real
                                    Projects !</span>
                                                            <span className="course-number">6/35 </span>
                                                            <span className="course-progressbar">
                                                                <span className="course-progressbar-filler"
                                                                    style={{ width: "95%" }}></span>
                                                            </span>
                                                        </span>

                                                        <span className="btn-option">
                                                            <i className="icon-feather-more-vertical"></i>
                                                        </span>
                                                        <div className="dropdown-option-nav"
                                                            uk-dropdown="pos: bottom-right ;mode : hover">
                                                            <ul>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-material-outline-dashboard"></i>
                                            Course Dashboard</span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-feather-video"></i>
                                            Resume Course</span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-feather-x"></i>
                                            Remove Course</span>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="course-intro.html">
                                                        <span className="notification-image">
                                                            <img src="../../assets/images/course/2.png" alt="" /> </span>
                                                        <span className="notification-text">
                                                            <span className="course-title">Learn Angular Fundamentals From The
                                    Beginning</span>
                                                            <span className="course-number">6/35 </span>
                                                            <span className="course-progressbar">
                                                                <span className="course-progressbar-filler"
                                                                    style={{ width: "95%" }}></span>
                                                            </span>
                                                        </span>

                                                        <span className="btn-option">
                                                            <i className="icon-feather-more-vertical"></i>
                                                        </span>
                                                        <div className="dropdown-option-nav"
                                                            uk-dropdown="pos: bottom-right ;mode : hover">
                                                            <ul>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-material-outline-dashboard"></i>
                                            Course Dashboard</span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-feather-video"></i>
                                            Resume Course</span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-feather-x"></i>
                                            Remove Course</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="course-intro.html">
                                                        <span className="notification-image">
                                                            <img src="../../assets/images/course/1.png" alt="" /> </span>
                                                        <span className="notification-text">
                                                            <span className="course-title">Ultimate Web Designer & Web Developer
                                </span>
                                                            <span className="course-number">6/35 </span>
                                                            <span className="course-progressbar">
                                                                <span className="course-progressbar-filler"
                                                                    style={{ width: "95%" }}></span>
                                                            </span>
                                                        </span>

                                                        <span className="btn-option">
                                                            <i className="icon-feather-more-vertical"></i>
                                                        </span>
                                                        <div className="dropdown-option-nav"
                                                            uk-dropdown="pos: top-right ;mode : hover">
                                                            <ul>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-material-outline-dashboard"></i>
                                            Course Dashboard</span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-feather-video"></i>
                                            Resume Course</span>
                                                                </li>
                                                                <li>
                                                                    <span>
                                                                        <i className="icon-feather-x"></i>
                                            Remove Course</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="dropdown-notifications-footer">
                                            <a href="#"> sell all</a>
                                        </div>
                                    </div>


                                    <a href="#" className="header-widget-icon"
                                        uk-tooltip="title: Notificiation ; pos: bottom ;offset:21">
                                        <i className="uil-bell"></i>
                                        <span>4</span>
                                    </a>

                                    <div uk-dropdown="pos: top-right;mode:click ; animation: uk-animation-slide-bottom-small"
                                        className="dropdown-notifications">

                                        <div className="dropdown-notifications-headline">
                                            <h4>Notifications </h4>
                                            <a href="#">
                                                <i className="icon-feather-settings"
                                                    uk-tooltip="title: Notifications settings ; pos: left"></i>
                                            </a>
                                        </div>

                                        <div className="dropdown-notifications-content" data-simplebar>

                                            <ul>
                                                <li className="notifications-not-read">
                                                    <a href="#">
                                                        <span className="notification-icon btn btn-soft-danger disabled">
                                                            <i className="icon-feather-thumbs-up"></i></span>
                                                        <span className="notification-text">
                                                            <strong>Adrian Mohani</strong> Like Your Comment On Course
                                <span className="text-primary">Javascript Introduction </span>
                                                            <br /> <span className="time-ago"> 9 hours ago </span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <span className="notification-icon btn btn-soft-primary disabled">
                                                            <i className="icon-feather-message-circle"></i></span>
                                                        <span className="notification-text">
                                                            <strong>Stella Johnson</strong> Replay Your Comments in
                                <span className="text-primary">Programming for Games</span>
                                                            <br /> <span className="time-ago"> 12 hours ago </span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <span className="notification-icon btn btn-soft-success disabled">
                                                            <i className="icon-feather-star"></i></span>
                                                        <span className="notification-text">
                                                            <strong>Alex Dolgove</strong> Added New Review In Course
                                <span className="text-primary">Full Stack PHP Developer</span>
                                                            <br /> <span className="time-ago"> 19 hours ago </span>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="notifications-not-read">
                                                    <a href="#">
                                                        <span className="notification-icon btn btn-soft-danger disabled">
                                                            <i className="icon-feather-share-2"></i></span>
                                                        <span className="notification-text">
                                                            <strong>Jonathan Madano</strong> Shared Your Discussion On Course
                                <span className="text-primary">Css Flex Box </span>
                                                            <br /> <span className="time-ago"> Yesterday </span>
                                                        </span>
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>


                                    </div>



                                    <a href="#" className="header-widget-icon" uk-tooltip="title: Message ; pos: bottom ;offset:21">
                                        <i className="uil-envelope-alt"></i>
                                        <span>1</span>
                                    </a>

                                    <div uk-dropdown=" pos: top-right;mode:click" className="dropdown-notifications">

                                        <div className="dropdown-notifications-headline">
                                            <h4>Messages</h4>
                                            <a href="#">
                                                <i className="icon-feather-settings"
                                                    uk-tooltip="title: Message settings ; pos: left"></i>
                                            </a>
                                        </div>

                                        <div className="dropdown-notifications-content" data-simplebar>

                                            <ul>
                                                <li className="notifications-not-read">
                                                    <a href="#">
                                                        <span className="notification-avatar">
                                                            <img src="../../assets/images/avatars/avatar-2.jpg" alt="" />
                                                        </span>
                                                        <div className="notification-text notification-msg-text">
                                                            <strong>Jonathan Madano</strong>
                                                            <p>Okay.. Thanks for The Answer I will be waiting for your...
                                </p>
                                                            <span className="time-ago"> 2 hours ago </span>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <span className="notification-avatar">
                                                            <img src="../../assets/images/avatars/avatar-3.jpg" alt="" />
                                                        </span>
                                                        <div className="notification-text notification-msg-text">
                                                            <strong>Stella Johnson</strong>
                                                            <p> Alex will explain you how to keep the HTML structure and all
                                    that...</p>
                                                            <span className="time-ago"> 7 hours ago </span>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <span className="notification-avatar">
                                                            <img src="../../assets/images/avatars/avatar-1.jpg" alt="" />
                                                        </span>
                                                        <div className="notification-text notification-msg-text">
                                                            <strong>Alex Dolgove</strong>
                                                            <p> Alia Joseph just joined Messenger! Be the first to send a
                                    welcome message..</p>
                                                            <span className="time-ago"> 19 hours ago </span>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <span className="notification-avatar">
                                                            <img src="../../assets/images/avatars/avatar-4.jpg" alt="" />
                                                        </span>
                                                        <div className="notification-text notification-msg-text">
                                                            <strong>Adrian Mohani</strong>
                                                            <p> Okay.. Thanks for The Answer I will be waiting for your...
                                </p>
                                                            <span className="time-ago"> Yesterday </span>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="dropdown-notifications-footer">
                                            <a href="#"> sell all <i className="icon-line-awesome-long-arrow-right"></i> </a>
                                        </div>
                                    </div>


                                </Fragment>

                            }

                            <a href="#" className="header-widget-icon profile-icon">
                                <img src="../../assets/images/avatars/avatar-2.jpg" alt="" className="header-profile-icon" />
                            </a>

                            <div uk-dropdown="pos: top-right ;mode:click" className="dropdown-notifications small">
                                {authentificated == true &&
                                    <a href="profile-1.html">

                                        <div className="dropdown-user-details">
                                            <div className="dropdown-user-avatar">
                                                <img src="../../assets/images/avatars/avatar-2.jpg" alt="" />
                                            </div>
                                            <div className="dropdown-user-name">
                                                {currentUser.username} <span>Students</span>
                                            </div>
                                        </div>

                                    </a>

                                }
                                <ul className="dropdown-user-menu">
                                    {authentificated == true &&
                                        <Fragment>

                                            <li>
                                                <a href="#">
                                                    <i className="icon-material-outline-dashboard"></i> Dashboard</a>
                                            </li>
                                            <li><a href="#">
                                                <i className="icon-feather-bookmark"></i> Bookmark </a>
                                            </li>
                                            <li><a href="profile-edit.html">
                                                <i className="icon-feather-settings"></i> Account Settings</a>
                                            </li>
                                            <li><a href="#" style={{ color: "#62d76b" }}>
                                                <i className="icon-feather-star"></i> Upgrade To Premium</a>
                                            </li>
                                        </Fragment>
                                    }
                                    <li>
                                        <a href="#" id="night-mode" className="btn-night-mode">
                                            <i className="icon-feather-moon"></i> Night mode
                        <span className="btn-night-mode-switch">
                                                <span className="uk-switch-button"></span>
                                            </span>
                                        </a>
                                    </li>
                                    <li className="menu-divider"></li>
                                    <li><a href="#">
                                        <i className="icon-feather-help-circle"></i> Help</a>
                                    </li>
                                    {authentificated == true && <li>
                                        <a href="#" onClick={(e) => { e.preventDefault(); handleSignOut() }}>
                                            <i className="icon-feather-log-out"></i>
                                            Déconnexion
                                        </a>
                                    </li>}

                                    {authentificated == false && <li>
                                        <a href="/connexion">
                                            <i className="icon-feather-log-in"></i>
                                            Se connecter
                                        </a>
                                    </li>}
                                </ul>


                            </div>

                            {authentificated == false &&
                                <a  style={{color: "white"}} href="/connexion" class="btn btn-default">Se connecter maintenant !</a>
                            }
                        </div>



                        <a className="uk-navbar-toggle uk-hidden@s"
                            uk-toggle="target: .nav-overlay; animation: uk-animation-fade" href="#">
                            <i style={{color: "white"}} className="uil-search icon-small"></i>
                        </a>

                        <a style={{color: "white"}} href="#" className="uil-user icon-small uk-hidden@s"
                            uk-toggle="target: .header-widget ; cls: is-active">
                        </a>

                    </div>


                </nav>

            </div>

        </header>

    )
}

export default Header
